import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Dialog } from '@ferris/react';
import { PropertyNotFoundModalProptypes, PropertyPlaybackModalProptypes } from '../properties';
import { CALL_STATUS, CallStatusContext, ModalContext } from '../Context';
import PropertyNotFoundModal from './PropertyNotFoundModal';
import PropertyPlaybackModal from './PropertyPlaybackModal';

const ModalHandler = (props) => {
    const {
        propertyNotFound,
        propertyPlayback
    } = props;

    const {
        callStatus
    } = useContext(CallStatusContext);
    const {
        showDialog
    } = useContext(ModalContext);
    return (
        <Dialog
            open={showDialog}
            fullScreen
            showFooter={false}
            showHeader={false}
            classes={cn('competitor-url-modal-container')}
        >
            {callStatus === CALL_STATUS.NOT_FOUND && (
                <PropertyNotFoundModal
                    {...propertyNotFound}
                />
            )}
            {callStatus === CALL_STATUS.SUCCESS && (
                <PropertyPlaybackModal
                    {...propertyPlayback}
                />
            )}
        </Dialog>
    );
};

ModalHandler.propTypes = {
    propertyPlayback: PropTypes.shape(PropertyPlaybackModalProptypes).isRequired,
    propertyNotFound: PropTypes.shape(PropertyNotFoundModalProptypes).isRequired
};

export default ModalHandler;
